import React from "react";
import { LazyLoadImages, ResponsiveImage } from "@quintype/components";
import { GlideCarousel } from "../../atoms/glide";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./story-element-slideshow.module.css";
const ImageSlideshowElement = props => {
  let resizeDone = false;

  const resize = () => {
    if (resizeDone === false) {
      global.dispatchEvent(new global.Event("resize"));
      resizeDone = true;
    }
  };
  const sliderDefaultSettings = {
    afterSlide: resize,
    perView: 1,
    arrow: true,
    dot: "",
    autoplay: 5000
  };

  const sliderSettings = Object.assign({}, sliderDefaultSettings, props); // Refactor to use spread operator

  const Slide = (image, index) => (
    <div onClick={() => props.onClickHandler(index)} styleName="slide" key={image.id}>
      <figure key={image.id} styleName="image-container">
        <LazyLoadImages margin={"0px"}>
          <ResponsiveImage
            slug={image["image-s3-key"]}
            metadata={image["metadata"]}
            aspect-ratio={[16, 9]}
            defaultWidth={480}
            widths={[250, 480, 640]}
            imgParams={{ auto: ["format", "compress"] }}
            styleName="image"
            alt={image.title || props.story.headline}
          />
        </LazyLoadImages>
      </figure>
      <p styleName="caption">{image.title}</p>
    </div>
  );

  const storyElements = get(props, ["element", "story-elements"], []);
  const sliderImages = storyElements.map((image, index) => Slide(image, index));

  const SliderWrapper = <GlideCarousel {...sliderSettings}>{sliderImages}</GlideCarousel>;

  return <div className="story-element-image-slideshow">{SliderWrapper}</div>;
};
ImageSlideshowElement.propTypes = {
  element: PropTypes.object,
  story: PropTypes.object,
  onClickHandler: PropTypes.func
};

export { ImageSlideshowElement };
